export default {
  getActiveProjectData(state: any) {
    return state.projects.find((item: any) => item.slug === state.activeProject)
  }
}
